import React, { useState } from "react";
import moment from "moment";
import axios from "axios";
import { toast } from "react-toastify";
import { formatTime } from "../../utils/tools";
import { AUDIENCE_UPDATE_NOTES } from "../../../endpoints";

const fmtDate = (d) => (d ? moment(d).format("DD-MM-YYYY") : "—");
const fmtDateTime = (d) => (d ? moment(d).format("DD MMM YYYY, h:mm a") : "—");

function Row({ label, children }) {
  return (
    <>
      <div className="lp-attr__k">{label}</div>
      <div className="lp-attr__v">{children}</div>
    </>
  );
}

function AttributesTab({ profile, token, onSaved }) {
  const [notes, setNotes] = useState(profile.privateNotes || "");
  const [saving, setSaving] = useState(false);
  const [dirty, setDirty] = useState(false);

  const minutes = parseInt(profile.totalStudyTime, 10) || 0;
  const sat = profile.satisfactionScore == null ? "—" : `${profile.satisfactionScore} / 10`;

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await axios.patch(
        AUDIENCE_UPDATE_NOTES(profile.id),
        { private_notes: notes },
        { headers: { Authorization: token } },
      );
      onSaved?.({ privateNotes: data.privateNotes, privateNotesUpdatedAt: data.privateNotesUpdatedAt });
      setDirty(false);
      toast.success("Private notes saved.");
    } catch (e) {
      toast.error("Could not save notes.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="lp-pad">
      <div className="lp-attr">
        <Row label="First name">{profile.learner?.first_name || "—"}</Row>
        <Row label="Last name">{profile.learner?.last_name || "—"}</Row>
        <Row label="Email">{profile.learner?.email || "—"}</Row>
        <Row label="User ID">{profile.userId || "—"}</Row>
        <Row label="Learning start">{fmtDate(profile.learningStart)}</Row>
        <Row label="Total study time">{formatTime(minutes)}</Row>
        <Row label="Recent activity">{fmtDateTime(profile.recentActivity)}</Row>
        <Row label="Unique visits">{profile.uniqueVisits ?? 0}</Row>
        <Row label="Opens">{profile.opens ?? 0}</Row>
        <Row label="Completions">{profile.completions ?? 0}</Row>
        <Row label="Satisfaction score">{sat}</Row>
        <Row label="Learning group">
          {profile.segment
            ? <span className="lp-tags"><span className="lp-tag">{profile.segment}</span></span>
            : "—"}
        </Row>
      </div>

      <div className="lp-notes">
        <div className="lp-notes__head">
          <span className="lp-notes__title">Private notes</span>
          <span className="lp-notes__badge">Visible only to your team</span>
        </div>
        <textarea
          className="lp-notes__area"
          value={notes}
          onChange={(e) => { setNotes(e.target.value); setDirty(true); }}
          placeholder="Add context your team should see — goals, blockers, renewal notes…"
        />
        <div className="lp-notes__foot">
          {profile.privateNotesUpdatedAt && !dirty && (
            <span className="lp-notes__saved">Saved {moment(profile.privateNotesUpdatedAt).fromNow()}</span>
          )}
          <button
            type="button"
            className="lp-btn lp-btn--primary"
            onClick={save}
            disabled={saving || !dirty}
          >
            {saving ? "Saving…" : "Save notes"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AttributesTab;
